import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
// GK-HUB: Campaign dashboard + wizard
import CampaignsDashboard from 'dashboard/components-next/Campaigns/Pages/CampaignsDashboard.vue';
import WhatsAppCampaignWizard from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/WhatsAppCampaignWizard.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// GK-HUB: Allow manager role for campaigns
const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'manager'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        // GK-HUB: Unified dashboard as default campaign page
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_dashboard', params: to.params };
          },
        },
        {
          path: 'dashboard',
          name: 'campaigns_dashboard',
          meta,
          component: CampaignsDashboard,
        },
        // GK-HUB: end unified dashboard
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        // GK-HUB: Advanced campaign wizard route
        {
          path: 'whatsapp/new',
          name: 'campaigns_whatsapp_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignWizard,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
